import Login from "../pages/login";
import PageNotFound from "../pages/not-found";
import ForgotPassword from "../pages/forgot-password";
import ResetPassword from "../pages/reset-password";
import SetupPassword from "../pages/setup-password";
import TwoFactorAuthentication from "../pages/two-factor-verify";
import CreateAccount from "../pages/create-account";
import VerifyAccount from "../pages/verify-account";
import LoginAsComponent from "../pages/login-as";
import AuthGuard from "./handler/auth-guard";
import TOTPAuthentication from "../pages/totp-otp-verify";
import TOTPSetup from "../pages/setup-totp";
import ScanOTPRequest from "../pages/scan-otp-request";
import { redirectionRoutes } from "./redirectionRoutes";


const publicRoutes = [
    {
        path: redirectionRoutes.login.path,
        element: <AuthGuard><Login /></AuthGuard>
    },
    {
        path: redirectionRoutes.createAccount.path,
        element: <AuthGuard><CreateAccount /></AuthGuard>
    },
    {
        path: redirectionRoutes.twoFactorAuthentication.path,
        element: <AuthGuard><TwoFactorAuthentication /></AuthGuard>
    },
    {
        path: redirectionRoutes.TOTPSetup.path,
        element: <AuthGuard><TOTPSetup /></AuthGuard>
    },
    {
        path: redirectionRoutes.TOTPAuthentication.path,
        element: <AuthGuard><TOTPAuthentication /></AuthGuard>
    },
    {
        path: redirectionRoutes.forgotPassword.path,
        element: <AuthGuard><ForgotPassword /></AuthGuard>
    },
    {
        path: redirectionRoutes.resetPasswordWithoutToken.path,
        element: <AuthGuard><ResetPassword /></AuthGuard>
    },
    {
        path: redirectionRoutes.setupPassword.path,
        element: <AuthGuard><SetupPassword /></AuthGuard>
    },
    {
        path: redirectionRoutes.verifyAccountWithToken.path,
        element: <AuthGuard><VerifyAccount /></AuthGuard>
    },
    {
        path: redirectionRoutes.pageNotFound.path,
        element: <PageNotFound />
    },
    {
        path: redirectionRoutes.loginAs.path,
        element: <LoginAsComponent />
    },
    {
        path: redirectionRoutes.scanOTPRequest.path,
        element: <ScanOTPRequest />
    },
];


export default publicRoutes;